import React from "react";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";

class BrandVerificationPopUp extends React.Component {
  render() {
    const brandName = this.props.brandName || "Amamzon India";
    return (
      <Typography.BodySmall color="light" shade="c000" className="mb-0 pb-0">
        {brandName} is only available for verified accounts.{" "}
        <u>
          <Typography.BodySmall
            component="a"
            onClick={(e) => {
              this.props.redirectToVerifications(e);
            }}
          >
            Click here
          </Typography.BodySmall>
        </u>{" "}
        to submit your account details for verification.
      </Typography.BodySmall>
    );
  }
}

export default BrandVerificationPopUp;
